import React from 'react';
import NavGroupAccordion from './navigation/NavGroupAccordion';
import SidebarIdentity from './SidebarIdentity';
import WorkspaceSwitcher from './WorkspaceSwitcher';
import BrandTagline from './BrandTagline';
import BrandWord from './BrandWord';
import { useNavigation } from '@/context/NavigationContext';
import { clearAccessToken } from '@/api/client';
import { useNavigate } from 'react-router-dom';
import { useMe } from '@/context/MeContext';
import BrandMark from './BrandMark';
import { IconLogout } from './Icons';

export default function DesktopSidebar() {
  const navigate = useNavigate();
  const { me } = useMe();
  const { navGroups, sidebarCollapsed, toggleSidebarCollapsed } = useNavigation();
  const collapsed = sidebarCollapsed;

  return (
    <aside
      className={`sidebar desktop-sidebar${collapsed ? ' sidebar--collapsed' : ''}`}
      data-testid="desktop-sidebar"
      data-sidebar-collapsed={collapsed ? 'true' : 'false'}
    >
      <div className={`sidebar-header${collapsed ? ' sidebar-header--collapsed' : ''}`}>
        <div className={`brand${collapsed ? ' brand--collapsed' : ''}`} data-testid="sidebar-brand">
          <BrandMark />
          {!collapsed ? (
            <div>
              <BrandWord className="brand-name" />
              <BrandTagline />
            </div>
          ) : null}
        </div>
        <button
          type="button"
          className={`sidebar-collapse-btn${collapsed ? ' sidebar-collapse-btn--collapsed' : ''}`}
          onClick={toggleSidebarCollapsed}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          aria-expanded={!collapsed}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          data-testid="sidebar-collapse-toggle"
        >
          <span className="sidebar-collapse-btn__icon" aria-hidden>
            {collapsed ? '›' : '‹'}
          </span>
        </button>
      </div>

      {me && !collapsed ? <SidebarIdentity /> : null}

      {!collapsed ? (
        <WorkspaceSwitcher sectionLabel="Current workspace" />
      ) : null}

      <NavGroupAccordion
        navGroups={navGroups}
        variant="desktop"
        iconOnly={collapsed}
        className="sidebar-nav"
        data-testid="desktop-sidebar-nav"
      />

      {collapsed ? (
        <div className="sidebar-footer sidebar-footer--collapsed">
          <button
            type="button"
            className="btn btn-ghost sidebar-signout-icon"
            title="Sign out"
            aria-label="Sign out"
            onClick={() => {
              clearAccessToken();
              navigate('/login', { replace: true });
            }}
          >
            <IconLogout className="nav-icon" />
          </button>
        </div>
      ) : (
        <div className="sidebar-footer">
          <button
            type="button"
            className="btn btn-ghost btn-block"
            onClick={() => {
              clearAccessToken();
              navigate('/login', { replace: true });
            }}
          >
            <IconLogout className="nav-icon" />
            Sign out
          </button>
        </div>
      )}
    </aside>
  );
}
